import { fetcher } from '@commenda/utils';
import {
  BulkActionTransactionsParams,
  BulkDeleteTransactionsByFiltersResponse,
  BulkDeleteTransactionsByIdsResponse,
} from './types';

export async function bulkDeleteTransactions(
  body: BulkActionTransactionsParams
): Promise<{
  success: boolean;
  error?: string;
  data?:
    | BulkDeleteTransactionsByIdsResponse
    | BulkDeleteTransactionsByFiltersResponse;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/transactions/bulk/delete`,
      {
        method: 'POST',
        body,
      },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to delete transactions',
      };
    }

    const data = await response.json();

    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to delete transactions';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
